<template>
  <div class="vouchers">
    <div class="subHead">
      <van-icon name="arrow-left" class="arrow" @click="goBack" />
      <span class="subHead-text">卡券管理</span>
    </div>
    <van-tabs v-model="active">
      <van-tab>
        <template #title>
          <van-badge :content="couponsTotal">
            我的卡券
          </van-badge>
        </template>
        <vouchersList @setCouponsTotal="(e) => { couponsTotal = e }" />
      </van-tab>
      <van-tab title="申请记录">
        <vouchersGet />
      </van-tab>
      <van-tab title="审核记录">
        <vouchersRecord />
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
import vouchersList from './vouchersList';
import vouchersGet from './vouchersGet';
import vouchersRecord from './vouchersRecord';
export default {
  name: 'Vouchers',
  components: {
    vouchersList,
    vouchersGet,
    vouchersRecord
  },
  data() {
    return {
      active: 0,
      couponsTotal: 0,
      couponsInfo: {}
    };
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      if (from.name === 'applySuccess') {
        vm.active = 1;
      }
    });
  },
  activated() {},
  methods: {
    goBack() {
      this.$router.push({ name: 'user' });
    },

  }
};
</script>

<style lang="less" scoped>
  .vouchers {
    width: 100%;
    height: calc(100vh);
    overflow-x: hidden;
    box-sizing: border-box;
    padding-bottom: 0.1rem;

    /deep/.van-tabs,
    .van-tabs__wrap {
      height: 0.47rem;
      .van-tabs__nav {
        background: rgba(250, 250, 250, 1);
      }
      .van-tabs__nav--line {
        color: #3b86ff;
      }
      .van-tab {
        color: #333;
      }
      .van-tab--active {
        color: #3b86ff;
      }
      .van-tabs__line {
        background-color: #3b86ff;
      }
      .van-tab__text--ellipsis {
        overflow: unset;
      }
    }
  }
</style>
